import { Button, Col, Divider, Form, Input, Modal, Row, Spin, Upload, message } from 'antd';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import FormAdjuntoTracking from '../../Components/Form_adjunto_tracking';
import { HOME_ROUTE } from '../../Components/Router/constant';
import { useFormContext } from '../../Context/DeclarationContext';
import { useTrackingContext } from '../../Context/TrackingContext';
import { getDocumentsByShortId, getUrlFileBase64FromPSS, updateDocEntity, uploadDocumentByDocId } from '../../Services/tracking';
import './index.css';
import './tracking.scss';

import { CloseOutlined, FileAddOutlined, PlusOutlined } from '@ant-design/icons';

const Tracking = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state: declarationState, dispatch: declarationDispatch } = useFormContext();
  const { state, dispatch } = useTrackingContext();
  const [documentDOCA, setDocumentDOCA] = useState<any[]>([]);
  const [photosFDVP, setPhotosFDVP] = useState<any[]>([]);
  const [photosFDV3, setPhotosFDV3] = useState<any[]>([]);

  const [shortId, setShortId] = useState<string | null>(null);
  const [deviceId, setDeviceId] = useState<string | null>(null);
  const [tooBig, setTooBig] = useState(false);
  const [tooBigPhoto, setTooBigPhoto] = useState(false);

  const [fiveFiles, setFiveFiles] = useState(false);
  const [sixFiles, setSixFiles] = useState(false);

  const [nonmbreFile, setNombreFile] = useState('');
  const [fileList, setFileList] = useState<any[]>([]);
  const [fileListPhoto, setFileListPhoto] = useState<any[]>([]);
  const [fileListPhotoThird, setFileListPhotoThird] = useState<any[]>([]);
  const [openAddDocModal, setOpenAddDocModal] = useState(false);
  const [reloadDocs, setReloadDocs] = useState(false);

  const [openModalPhotos, setOpenModalPhotos] = useState(false);
  const [openModalPhotosThird, setOpenModalPhotosThird] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleLoadDocuments = async () => {
      const searchParams = new URLSearchParams(location.search);
      const shortId = searchParams.get('token') ?? '';
      if (shortId) {
        setLoading(true);
        try {
          const response = await getDocumentsByShortId(shortId);

          declarationDispatch({
            type: 'UPDATE_THIRD_PARTY_INVOLVED',
            payload: {
              propertyInvolved: response.data.thirdPartyInvolved?.propertyInvolved,
              peopleInjured: response.data.thirdPartyInvolved?.peopleInjured,
            },
          });

          declarationDispatch({
            type: 'UPDATE_DESCRIPTIONS_ACCIDENT',
            payload: {
              description: response.data?.description,
            },
          });

          declarationDispatch({
            type: 'UPDATE_SHORT_ID',
            payload: response.data?.shortId,
          });

          declarationDispatch({
            type: 'UPDATE_POLICE_REPORT',
            payload: {
              claimDate: response.data?.claimDate,
              claimTime: response.data?.claimTime,
            },
          });

          declarationDispatch({
            type: 'UPDATE_VEHICLE_PATENT',
            payload: {
              deviceId: response.data?.vehicle?.deviceId,
            },
          });
          setDeviceId(response.data?.vehicle?.deviceId);

          declarationDispatch({
            type: 'UPDATE_DRIVER',
            payload: response.data?.driver,
          });

          declarationDispatch({
            type: 'UPDATE_DECLARANT',
            payload: response.data?.declarant,
          });

          declarationDispatch({
            type: 'UPDATE_ADDRESS',
            payload: response.data?.address,
          });

          dispatch({
            type: 'UPDATE_DOCUMENTS',
            payload: response.data?.documents || [],
          });

          setShortId(shortId);
          setLoading(false);
        } catch (error) {
          console.error(error);
          if (error?.status === 401 || error?.status === 404) {
            navigate(`${HOME_ROUTE}?status=401`);

            setLoading(false);
          }
        }
      }
    };
    handleLoadDocuments();
  }, [reloadDocs]);

  const handleCancelClose = () => {
    // console.log('handleCancelClose');
    setFileList([]);
    // setViewUploadBtn(false);
    setNombreFile('');
    setOpenAddDocModal(false);
    setTooBig(false);
    setFiveFiles(false);
  };

  const handleCancelClosePhotos = () => {
    setFileListPhoto([]);
    setOpenModalPhotos(false);
    setTooBigPhoto(false);
    setSixFiles(false);
  };

  const handleCancelClosePhotosThird = () => {
    setFileListPhotoThird([]);
    setOpenModalPhotosThird(false);
    setTooBigPhoto(false);
    setSixFiles(false);
  };

  const contentTypeMap: any = {
    pdf: 'application/pdf',
    png: 'image/png',
    jpg: 'image/jpg',
    jpeg: 'image/jpeg',
    jfif: 'image/jpeg',
    gif: 'image/gif',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    txt: 'text/plain',
    csv: 'text/csv',
    xml: 'application/xml',
    json: 'application/json',
    zip: 'application/zip',
    rar: 'application/x-rar-compressed',
    '7z': 'application/x-7z-compressed',
    tar: 'application/x-tar',
    gz: 'application/gzip',
    bz2: 'application/x-bzip2',
    mp3: 'audio/mpeg',
    wav: 'audio/wav',
    ogg: 'audio/ogg',
    mp4: 'video/mp4',
    mov: 'video/quicktime',
    avi: 'video/x-msvideo',
    wmv: 'video/x-ms-wmv',
    flv: 'video/x-flv',
    mpeg: 'video/mpeg',
    webm: 'video/webm',
    webp: 'image/webp',
    svg: 'image/svg+xml',
    html: 'text/html',
    css: 'text/css',
    js: 'application/javascript',
    php: 'application/x-httpd-php',
  };

  const handleOpenAddModal = () => {
    setOpenAddDocModal(true);
  };

  const handleOpenModalPhoto = () => {
    setOpenModalPhotos(true);
  };

  const handleOpenModalPhotoThird = () => {
    setOpenModalPhotosThird(true);
  };

  const handlePreview = async (file: any) => {
    const fileName = file;
    try {
      const response = await getUrlFileBase64FromPSS(fileName?.name);
      const fileExtension = contentTypeMap[fileName?.name.split('.').pop().toLowerCase()];
      const byteCharacters = atob(response.data.buffer);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const file = new Blob([byteArray], {
        type: fileExtension,
      });

      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } catch (error) {
      console.error(error);
      if (error.status === 404) {
        // Notifications.error('No se encontro el archivo', 'Por favor intente mas tarde.');
      }
      console.log(error, 'eROR');
    }
  };
  const handleDocChange = async (e: any) => {
    setReloadDocs(false);
    setTooBig(false);
    setFiveFiles(false);
    setFileList(e.fileList?.slice(-1));
  };

  const handleDocChangeThird = async (e: any) => {
    setReloadDocs(false);
    setTooBig(false);
    // setFiveFiles(false)
    setFileListPhotoThird(e.fileList?.slice(-1));
  };

  const handleDeleteDoc = async (id: any) => {
    setReloadDocs(true);
    const docObj = {
      filename: null,
    };

    try {
      const { data } = await updateDocEntity(id, docObj);
      // setReloadDocs(true)
      handleCancelClose();
    } catch (error) {
      console.log(error, 'error');
    } finally {
      handleCancelClosePhotos();
      setReloadDocs(false);
    }
  };

  const handlePhotoChange = async (e: any) => {
    setReloadDocs(false);
    setTooBigPhoto(false);
    setSixFiles(false);
    setFileListPhoto(e.fileList?.slice(-1));
  };

  const handleUploadAdditionalDoc = async () => {
    setReloadDocs(false);

    const saveDocsObj = state.documents
      ?.filter((item: any) => item.documentType?.code?.includes('DOCA'))
      .find((item: any) => item.filename === null || item.filename === '');

    const docObj = {
      description: nonmbreFile,
    };

    try {
      const { data } = await uploadDocumentByDocId(fileList[0].originFileObj, saveDocsObj?.id);
      const response = await updateDocEntity(saveDocsObj?.id, docObj);
      setReloadDocs(true);
      setOpenAddDocModal(false);
      setNombreFile('');
      setFileList([]);
      setFileList([
        {
          name: fileList[0]?.originFileObj?.name,
          url: data[0].url,
          isActive: true,
          status: 'done',
        },
      ]);
    } catch (error) {
      if (error?.data?.statusCode === 409) {
        message.error('El tipo de documento que adjunto no está permitido.');
      }
      if (error?.status === 400) {
        setFiveFiles(true);
        setFileList([
          {
            name: fileList[0]?.originFileObj?.name,
            url: null,
            isActive: true,
            status: 'error',
          },
        ]);
      }
      if (error?.status === 413) {
        setFileList([
          {
            name: fileList[0]?.originFileObj?.name,
            url: null,
            isActive: true,
            status: 'error',
          },
        ]);
        setTooBig(true);
        return {
          ...fileList[0]?.originFileObj?.name,
          status: 'error',
          error: 'File size exceeds the limit (10MB)',
        };
      }
    } finally {
      setFileList([]);
    }

    // try {

    //   console.log(data, 'data555');
    // } catch (error) {
    //   console.log(error, 'errorrrrrrrrrr');
    // }
  };
  const handleUploadAdditionalPhoto = async () => {
    setReloadDocs(false);

    const saveDocsObj = state.documents
      ?.filter((item: any) => item.documentType?.code?.includes('FDVP'))
      .find((item: any) => item.filename === null || item.filename === '');
    try {
      const { data } = await uploadDocumentByDocId(fileListPhoto[0].originFileObj, saveDocsObj?.id);
      setReloadDocs(true);
      setOpenModalPhotos(false);
      setNombreFile('');
      setFileListPhoto([]);
      setFileListPhoto([
        {
          name: fileListPhoto[0]?.name,
          url: data[0].url,
          isActive: true,
          status: 'done',
        },
      ]);
    } catch (error) {
      console.log(error);
      if (error?.status === 400) {
        setSixFiles(true);
        setFileListPhoto([
          {
            name: fileListPhoto[0]?.originFileObj?.name,
            url: null,
            isActive: true,
            status: 'error',
          },
        ]);
      }
      if (error?.data?.statusCode === 409) {
        message.error('El tipo de documento que adjunto no está permitido.');
      }
      if (error?.status === 413) {
        setFileListPhoto([
          {
            name: fileListPhoto[0]?.originFileObj?.name,
            url: null,
            isActive: true,
            status: 'error',
          },
        ]);
        setTooBigPhoto(false);
        return {
          ...fileListPhoto[0]?.originFileObj?.name,
          status: 'error',
          error: 'File size exceeds the limit (10MB)',
        };
      }
    } finally {
      setFileListPhoto([]);
    }
  };

  const handleUploadAdditionalPhotoThird = async () => {
    setReloadDocs(false);

    const requiredSaveDocsObj = state.documents
      ?.filter((item: any) => item.documentType?.code?.includes('FDV31'))
      .find((item: any) => item.filename === null || item.filename === '');

    let saveDocsObj;
    let index = 2;

    do {
      const expectedCode = `FDV3${index}`;
      const filtered = state.documents
        ?.filter((item) => item.documentType?.code?.includes('FDV3'))
        .find((item) => item.documentType?.code === expectedCode && (item.filename === null || item.filename === ''));

      saveDocsObj = filtered;

      index++;
    } while (!saveDocsObj && index <= 6);

    try {
      const { data } = await uploadDocumentByDocId(
        fileListPhotoThird[0].originFileObj,
        requiredSaveDocsObj !== undefined ? requiredSaveDocsObj?.id : saveDocsObj?.id
      );
      setReloadDocs(true);
      setOpenModalPhotosThird(false);
      setNombreFile('');
      setFileListPhoto([]);
      setFileListPhoto([
        {
          name: fileListPhoto[0]?.name,
          url: data[0].url,
          isActive: true,
          status: 'done',
        },
      ]);
      setSixFiles(false);
    } catch (error) {
      console.log(error);
      if (error?.status === 400) {
        setSixFiles(true);
        setFileListPhotoThird([
          {
            name: fileListPhoto[0]?.originFileObj?.name,
            url: null,
            isActive: true,
            status: 'error',
          },
        ]);
      }
      if (error?.data?.statusCode === 409) {
        console.log('comon');
        message.error('El tipo de documento que adjunto no está permitido.');
      }
      if (error?.status === 413) {
        setFileListPhotoThird([
          {
            name: fileListPhoto[0]?.originFileObj?.name,
            url: null,
            isActive: true,
            status: 'error',
          },
        ]);
        setTooBigPhoto(false);
        return {
          ...fileListPhoto[0]?.originFileObj?.name,
          status: 'error',
          error: 'File size exceeds the limit (10MB)',
        };
      }
    } finally {
      setFileListPhotoThird([]);
    }
  };

  const documentFinder = state.documents?.find((item: any) => item.documentType.code.includes('FDVP') && item.filename !== '')?.filename;

  const signedDeclaration = state.documents?.find((item: any) => item.documentType.code.includes('FDF') && item.filename !== '')?.filename;

  const rutDoc = state.documents?.find((item: any) => item.documentType.code.includes('DOCID') && item.filename !== '')?.filename;

  const licenseDoc = state.documents?.find((item: any) => item.documentType.code.includes('LIC') && item.filename !== '')?.filename;

  console.log(
    documentFinder !== undefined && rutDoc !== undefined && licenseDoc !== undefined && signedDeclaration !== undefined,
    'signedDeclaration'
  );

  useEffect(() => {
    setDocumentDOCA(state.documents?.filter((item: any) => item.documentType.code.includes('DOCA') && item.name !== null) || []);
    setPhotosFDVP(state.documents?.filter((item: any) => item.documentType.code.includes('FDVP') && item.name !== null) || []);
    setPhotosFDV3(state.documents?.filter((item: any) => item.documentType.code.includes('FDV3') && item.name !== null) || []);
  }, [state]);
  return (
    <>
      <Spin spinning={loading} fullscreen />
      {shortId && (
        <div className="attach_document_tracking">
          <div className="subtitle">
            ID de seguimiento: <strong className="text_time">{shortId}</strong> - Patente <strong className="text_time">{deviceId}</strong>
          </div>
          <div className="subtitle-2">
            En esta sección debe ingresar los documentos relacionados con su siniestro, con un peso máximo de 10MB{' '}
            <strong>(JPG, PNG, JPEG, PDF)</strong>
          </div>

          <Form>
            <Row
              gutter={[16, 16]}
              justify={'center'}
              style={{
                maxWidth: '98%',
              }}
            >
              <Col span={8}>
                <label className="classLabel">Requerimiento</label>
              </Col>
              <Col span={8}>
                <label className="classLabel">Nombre</label>
              </Col>
              <Col
                span={3}
                style={{
                  textAlign: 'center',
                }}
              >
                <label className="classLabel">Adjuntar/firmar</label>
              </Col>
              <Col
                span={3}
                style={{
                  textAlign: 'center',
                }}
              >
                <label className="classLabel">Visualizar</label>
              </Col>
              <Col span={2}>
                <label className="classLabel"></label>
              </Col>
            </Row>

            {// traer del estado los documentos que se tengan isActive true
            state.documents
              ?.filter(
                (doc) =>
                  doc.required &&
                  !doc.documentType.code.includes('FDVP') &&
                  !doc.documentType.code.includes('FDV3') &&
                  !doc.documentType.code.includes('DOCA')
              )
              .map((item: any, index: number) => {
                if (item.state) {
                  return (
                    <FormAdjuntoTracking
                      key={index}
                      handleDeleteDoc={handleDeleteDoc}
                      obligatorio={item.required}
                      nombre={item.documentType.name}
                      nombreAdjunto={item.filename}
                      adjuntar={true}
                      visualizar={false}
                      componentFirma={item.documentType.code}
                      documentType={item.documentType.code}
                      filename={item.filename}
                      documentId={item.id}
                      description={item.description}
                    />
                  );
                }
              })}

            {/* {// traer del estado los documentos que se tengan isActive true
            state.documents
              ?.filter((doc) => !doc.documentType.code.includes('FDVP') && !doc.required && !!doc.filename)
              .map((item: any, index: number) => {
                if (item.state) {
                  return (
                    <FormAdjuntoTracking
                      key={index}
                      obligatorio={item.required}
                      nombre={item.documentType.name}
                      nombreAdjunto={item.filename}
                      adjuntar={true}
                      visualizar={false}
                      componentFirma={item.documentType.code}
                      documentType={item.documentType.code}
                      filename={item.filename}
                      documentId={item.id}
                    />
                  );
                }
              })} */}
            {documentDOCA
              .filter((doc) => !!doc.filename)
              .map((item: any, index: number) => {
                if (item.state) {
                  return (
                    <FormAdjuntoTracking
                      key={index}
                      handleDeleteDoc={handleDeleteDoc}
                      obligatorio={item.required}
                      nombre={item.description}
                      nombreAdjunto={item.filename}
                      adjuntar={true}
                      visualizar={false}
                      componentFirma={item.documentType.code}
                      documentType={item.documentType.code}
                      filename={item.filename}
                      documentId={item.id}
                      description={item.description}
                    />
                  );
                }
              })}

            <Divider />
            <Row
              gutter={[16, 16]}
              style={{
                marginTop: '20px',
              }}
            >
              <Col span={24}>
                <Button
                  onClick={handleOpenAddModal}
                  style={{
                    color: '#22B260',
                    borderColor: '#22B260',
                    borderRadius: '36px',
                    fontWeight: '600',
                    height: '38px',
                    fontSize: '16px',
                    backgroundColor: 'white',
                  }}
                >
                  <PlusOutlined /> Agregar nuevo documento adicionales
                </Button>
              </Col>
            </Row>
          </Form>
          <Divider
            style={{
              marginTop: '90px',
            }}
          />

          {state.documents?.filter((item: any) => item.documentType.code.includes('FDVP')).length > 0 && (
            <div>
              <div className="title">Adjuntar fotografías y/o videos del vehículo propio</div>
              <li>Fotografías con los daños al vehículo asegurado considerando la placa patente.</li>
              <li style={{ display: 'none' }}>Fotografías con los daños a tercero considerando la placa patente (en caso de que haya terceros).</li>
              <Row
                gutter={[16, 16]}
                justify={'center'}
                style={{
                  maxWidth: '98%',
                  marginTop: '32px',
                }}
              >
                <Col span={19}>
                  <label className="classLabel">Nombre</label>
                </Col>
                <Col
                  span={3}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <label className="classLabel">Visualizar</label>
                </Col>
                <Col span={2}>
                  <label className="classLabel"></label>
                </Col>
              </Row>

              <Row style={{ padding: '15px 15px', backgroundColor: '#FAFAFA', borderRadius: '8px' }}>
                Fotos daños vehiculo <span style={{ color: 'rgba(0, 0, 0, 0.65)', marginLeft: '8px' }}>(Obligatorio minimo 1)</span>
              </Row>

              {photosFDVP
                .sort((a, b) => a - b)
                .filter((doc) => !!doc.filename)
                .map((item: any, index: number) => {
                  if (item.state) {
                    return (
                      <FormAdjuntoTracking
                        key={index}
                        obligatorio={item.required}
                        handleDeleteDoc={handleDeleteDoc}
                        nombreAdjunto={item.filename}
                        adjuntar={true}
                        visualizar={false}
                        componentFirma={item.documentType.code}
                        documentType={item.documentType.code}
                        filename={item.filename}
                        documentId={item.id}
                        description={item.description}
                      />
                    );
                  }
                })}
              <Row
                gutter={[16, 16]}
                style={{
                  marginTop: '20px',
                  marginBottom: '50px',
                }}
              >
                <Col span={24}>
                  <Button
                    onClick={handleOpenModalPhoto}
                    style={{
                      color: '#22B260',
                      borderColor: '#22B260',
                      borderRadius: '36px',
                      fontWeight: '600',
                      height: '38px',
                      fontSize: '16px',
                      backgroundColor: 'white',
                    }}
                  >
                    <PlusOutlined /> Adjuntar imagen
                  </Button>
                </Col>
              </Row>
            </div>
          )}

          {state.documents?.filter((item: any) => item.documentType.code.includes('FDV3')).length > 0 && (
            <div>
              <div className="title">Adjuntar fotografías y/o videos del vehiculo o bien del tercero.</div>
              <li>Fotografías con los daños a tercero considerando la placa patente (en caso de que haya terceros).</li>
              <li style={{ display: 'none' }}></li>
              <Row
                gutter={[16, 16]}
                justify={'center'}
                style={{
                  maxWidth: '98%',
                  marginTop: '32px',
                }}
              >
                <Col span={19}>
                  <label className="classLabel">Nombre</label>
                </Col>
                <Col
                  span={3}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <label className="classLabel">Visualizar</label>
                </Col>
                <Col span={2}>
                  <label className="classLabel"></label>
                </Col>
              </Row>

              <Row style={{ padding: '15px 15px', backgroundColor: '#FAFAFA', borderRadius: '8px' }}>Fotos daños vehiculo tercero</Row>

              {photosFDV3
                .sort((a, b) => a - b)
                .filter((doc) => !!doc.filename)
                .map((item: any, index: number) => {
                  if (item.state) {
                    return (
                      <FormAdjuntoTracking
                        key={index}
                        obligatorio={item.required}
                        handleDeleteDoc={handleDeleteDoc}
                        nombreAdjunto={item.filename}
                        adjuntar={true}
                        visualizar={false}
                        componentFirma={item.documentType.code}
                        documentType={item.documentType.code}
                        filename={item.filename}
                        documentId={item.id}
                        description={item.description}
                      />
                    );
                  }
                })}
              <Row
                gutter={[16, 16]}
                style={{
                  marginTop: '20px',
                }}
              >
                <Col span={24}>
                  <Button
                    onClick={handleOpenModalPhotoThird}
                    style={{
                      color: '#22B260',
                      borderColor: '#22B260',
                      borderRadius: '36px',
                      fontWeight: '600',
                      height: '38px',
                      fontSize: '16px',
                      backgroundColor: 'white',
                    }}
                  >
                    <PlusOutlined /> Adjuntar imagen
                  </Button>
                </Col>
              </Row>
            </div>
          )}

          <Row>
            <Col span={24} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '32px' }}>
              <Button
                disabled={!(documentFinder !== undefined && rutDoc !== undefined && licenseDoc !== undefined && signedDeclaration !== undefined)}
                className="btnHome"
                onClick={() => {
                  localStorage.removeItem('token');
                  return navigate(HOME_ROUTE);
                }}
              >
                Volver al Home
              </Button>
            </Col>
          </Row>
        </div>
      )}
      <Modal
        closeIcon={
          <CloseOutlined
            onClick={handleCancelClose}
            style={{
              color: '#22B260',
              padding: '5px 5px',
              borderRadius: '6px',
              backgroundColor: 'rgba(34, 178, 96, 0.06)',
            }}
          />
        }
        open={openAddDocModal}
        footer={null}
        onCancel={handleCancelClose}
        width={500}
        maskClosable={false}
      >
        <Row>
          <Col style={{ fontWeight: '600', fontSize: '18px', marginTop: '8px' }}>Adjuntar Documento</Col>
          <Col>Agregue el documento y asegúrese que toda la información este correcta. </Col>
        </Row>
        <Row style={{ marginLeft: '40px', marginRight: '70px', marginTop: '16px' }}>
          <span>Nombre</span>
          <Input value={nonmbreFile} onChange={(e) => setNombreFile(e.target.value)} style={{ backgroundColor: '#F5F5F5' }} />
          {nonmbreFile.length > 1 && nonmbreFile.length > 25 ? <span style={{ color: 'red' }}>Debe tener máximo 25 caracteres</span> : null}
        </Row>
        <Row
          align={'middle'}
          justify={'center'}
          style={{
            padding: '15px 30px',
            backgroundColor: '#FFFFFF',
            flexDirection: 'column',
            marginLeft: '40px',
            marginRight: '70px',
            border: '1px solid #e0e0e0',
            marginTop: '30px',
          }}
        >
          <Upload
            name="avatar"
            customRequest={() => {}}
            beforeUpload={() => false}
            listType="picture"
            maxCount={1}
            fileList={[...fileList]}
            onChange={(e) => handleDocChange(e)}
            showUploadList={true}
            style={{ maxWidth: '150px' }}
            onPreview={handlePreview}
          >
            <Row align={'middle'} justify={'center'} style={{ cursor: 'pointer' }}>
              <FileAddOutlined style={{ fontSize: '42px', color: '#969696' }} />
              <span style={{ color: '#969696' }}>Agregar archivo</span>
            </Row>
          </Upload>
          {tooBig ? <span style={{ color: 'red', marginTop: '16px' }}>Archivo supera los 10 MB</span> : null}
          {fiveFiles ? <span style={{ color: 'red', marginTop: '16px' }}>No se pueden agregar mas de 5 archivos adicionales</span> : null}
        </Row>
        <Row>
          <Button
            onClick={handleCancelClose}
            style={{
              width: '120px',
              borderRadius: '36px',
              border: '1px solid #22B260',
              color: '#22B260',
              backgroundColor: 'white',
              height: '38px',
              marginTop: '16px',
              marginLeft: '40px',
              marginRight: '25px',
            }}
          >
            Cancelar
          </Button>
          {fileList.length >= 1 && nonmbreFile.length > 1 && nonmbreFile.length <= 25 ? (
            <Button
              onClick={handleUploadAdditionalDoc}
              style={{
                width: '200px',
                borderRadius: '36px',
                color: 'white',
                backgroundColor: '#22B260',
                height: '38px',
                marginTop: '16px',
              }}
            >
              Cargar documento
            </Button>
          ) : null}
        </Row>
      </Modal>

      <Modal
        closeIcon={
          <CloseOutlined
            onClick={handleCancelClosePhotos}
            style={{
              color: '#22B260',
              padding: '5px 5px',
              borderRadius: '6px',
              backgroundColor: 'rgba(34, 178, 96, 0.06)',
            }}
          />
        }
        open={openModalPhotos}
        footer={null}
        onCancel={handleCancelClosePhotos}
        width={500}
        maskClosable={false}
      >
        <Row>
          <Col style={{ fontWeight: '600', fontSize: '18px', marginTop: '8px' }}>Adjuntar imagen</Col>
          <Col>Agregue la imagen/video y asegúrese que toda la información este correcta. </Col>
        </Row>
        <Row
          align={'middle'}
          justify={'center'}
          style={{
            padding: '15px 30px',
            backgroundColor: '#FFFFFF',
            flexDirection: 'column',
            border: '1px solid #e0e0e0',
            marginLeft: '40px',
            marginRight: '70px',
            marginTop: '30px',
          }}
        >
          <Upload
            name="avatar"
            customRequest={() => {}}
            listType="picture"
            maxCount={1}
            fileList={[...fileListPhoto]}
            onChange={(e) => handlePhotoChange(e)}
            showUploadList={true}
            beforeUpload={() => false}
            style={{ maxWidth: '150px' }}
            onPreview={handlePreview}
          >
            <Row align={'middle'} justify={'center'} style={{ cursor: 'pointer' }}>
              <FileAddOutlined style={{ fontSize: '42px', color: '#969696' }} />
              <span style={{ color: '#969696' }}>Agregar archivo</span>
            </Row>
          </Upload>
          {tooBigPhoto ? <span style={{ color: 'red', marginTop: '16px' }}>Archivo supera los 10 MB</span> : null}
          {sixFiles ? <span style={{ color: 'red', marginTop: '16px' }}>No se pueden agregar mas de 6 archivos adicionales</span> : null}
        </Row>
        <Row>
          <Button
            onClick={handleCancelClosePhotos}
            style={{
              width: '120px',
              borderRadius: '36px',
              border: '1px solid #22B260',
              color: '#22B260',
              backgroundColor: 'white',
              height: '38px',
              marginTop: '16px',
              marginLeft: '40px',
              marginRight: '25px',
            }}
          >
            Cancelar
          </Button>

          <Button
            onClick={handleUploadAdditionalPhoto}
            style={{
              width: '200px',
              borderRadius: '36px',
              color: 'white',
              backgroundColor: '#22B260',
              height: '38px',
              marginTop: '16px',
            }}
          >
            Cargar documento
          </Button>
        </Row>
      </Modal>

      <Modal
        closeIcon={
          <CloseOutlined
            onClick={handleCancelClosePhotosThird}
            style={{
              color: '#22B260',
              padding: '5px 5px',
              borderRadius: '6px',
              backgroundColor: 'rgba(34, 178, 96, 0.06)',
            }}
          />
        }
        open={openModalPhotosThird}
        footer={null}
        onCancel={handleCancelClosePhotosThird}
        width={500}
        maskClosable={false}
      >
        <Row>
          <Col style={{ fontWeight: '600', fontSize: '18px', marginTop: '8px' }}>Adjuntar imagen</Col>
          <Col>Agregue la imagen/video y asegúrese que toda la información este correcta. </Col>
        </Row>
        <Row
          align={'middle'}
          justify={'center'}
          style={{
            padding: '15px 30px',
            backgroundColor: '#FFFFFF',
            flexDirection: 'column',
            border: '1px solid #e0e0e0',
            marginLeft: '40px',
            marginRight: '70px',
            marginTop: '30px',
          }}
        >
          <Upload
            name="avatar"
            customRequest={() => {}}
            listType="picture"
            maxCount={1}
            fileList={[...fileListPhotoThird]}
            onChange={(e) => handleDocChangeThird(e)}
            showUploadList={true}
            beforeUpload={() => false}
            style={{ maxWidth: '150px' }}
            onPreview={handlePreview}
          >
            <Row align={'middle'} justify={'center'} style={{ cursor: 'pointer' }}>
              <FileAddOutlined style={{ fontSize: '42px', color: '#969696' }} />
              <span style={{ color: '#969696' }}>Agregar archivo</span>
            </Row>
          </Upload>
          {tooBigPhoto ? <span style={{ color: 'red', marginTop: '16px' }}>Archivo supera los 10 MB</span> : null}
          {sixFiles ? <span style={{ color: 'red', marginTop: '16px' }}>No se pueden agregar mas de 6 archivos adicionales</span> : null}
        </Row>
        <Row>
          <Button
            onClick={handleCancelClosePhotosThird}
            style={{
              width: '120px',
              borderRadius: '36px',
              border: '1px solid #22B260',
              color: '#22B260',
              backgroundColor: 'white',
              height: '38px',
              marginTop: '16px',
              marginLeft: '40px',
              marginRight: '25px',
            }}
          >
            Cancelar
          </Button>

          <Button
            onClick={handleUploadAdditionalPhotoThird}
            style={{
              width: '200px',
              borderRadius: '36px',
              color: 'white',
              backgroundColor: '#22B260',
              height: '38px',
              marginTop: '16px',
            }}
          >
            Cargar documento
          </Button>
        </Row>
      </Modal>
    </>
  );
};

export default Tracking;
